import { Flex, Label, Text } from '@approvalmax/ui/src/components';
import { memo } from 'react';
import { useFormContext } from 'react-hook-form';

import { NotificationError } from '../NotificationError/NotificationError';
import { useGetSections } from './StepFour.hooks';
import { messages } from './StepFour.messages';
import { StepFourProps } from './StepFour.types';

export const StepFour = memo<StepFourProps>((props) => {
    const { fields = [], errorMessages, isLoading } = props;

    const form = useFormContext<Record<string, string>>();

    const sections = useGetSections(fields);

    return (
        <Flex spacing='32' direction='column'>
            {errorMessages.length > 0 && <NotificationError errorMessages={errorMessages} />}

            <Text font='label'>{isLoading ? messages.titleInLoading : messages.title}</Text>

            <Flex spacing='32' direction='column'>
                {sections.map((section) => (
                    <Flex key={section.name}>
                        <Text font='headline' fontSize='xxsmall'>
                            {section.name}
                        </Text>

                        <Flex container>
                            {section.fields.map((field) => (
                                <Flex size={6} key={field.path} spacing='4' direction='column'>
                                    <Label>{field.field.label}</Label>

                                    <Text font='body'>{form.getValues(field.path) || '-'}</Text>
                                </Flex>
                            ))}
                        </Flex>
                    </Flex>
                ))}
            </Flex>
        </Flex>
    );
});

StepFour.displayName = 'StepFour';
